import { createContext } from "react";

export const MyUserContext = createContext();